import { OrderClient } from '@frontend/order/api';
import { Order } from '@frontend/order/types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

export const useOrderUpdate = () => {
    const navigate = useNavigate();
    const { accountId, orderId } = useParams();
    const dispatch = useAppDispatch();
    const [order, setOrder] = useState<Order | null>(null);

    useEffect(() => {
        if (!accountId || !orderId) return;
        OrderClient.fetchOrder(accountId, orderId).then((order) => {
            setOrder(order);
        });
    }, [accountId, orderId]);

    const onCancel = () => {
        navigate(-1);
    };

    const onSubmitSuccess = (order: Order) => {
        navigate(`/accounts/${order.account_id}/orders/${order.id}/detail`);
    };

    return {
        order,
        onCancel,
        onSubmitSuccess,
        dispatch
    };
};
